import type { CSSProperties } from 'react';
import { AdminIcon, adminActionIcons, adminIconSize, adminTokens } from '../../admin-ui';
import { useClientContext } from '../../hooks/useClientContext';
import { useClientContextRouteScope } from './useClientContextScope';

export function ClientContextBanner() {
  const { clientContext } = useClientContext();
  const { bannerMessage } = useClientContextRouteScope();

  if (clientContext === null) return null;

  return (
    <div style={bannerStyle} role="status" aria-live="polite">
      <AdminIcon icon={adminActionIcons.clientContext} size={adminIconSize.inline} />
      <span>
        <strong>Client View: {clientContext.name}</strong>
        {bannerMessage ? ` ${bannerMessage}` : null}
      </span>
    </div>
  );
}

// Client-context summary in the admin chrome: a warm tint so a scoped view
// stays obvious on every page, distinct from the info/error status tones.
const bannerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: adminTokens.spacing.sm,
  padding: `${adminTokens.spacing.sm} ${adminTokens.spacing.xl}`,
  backgroundColor: adminTokens.context.background,
  // Same 2 px top/bottom edges as before, so the workspace below keeps its height.
  borderTop: `2px solid ${adminTokens.context.border}`,
  borderBottom: `2px solid ${adminTokens.context.border}`,
  color: adminTokens.context.text,
  fontSize: adminTokens.typography.body.size,
  lineHeight: 1.4,
};
